export class DirectoryRoleAssignmentSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleId",
            "baseName": "roleId",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleName",
            "baseName": "roleName",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleType",
            "baseName": "roleType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "principalId",
            "baseName": "principalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "principalName",
            "baseName": "principalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "principalSubtitle",
            "baseName": "principalSubtitle",
            "type": "string",
            "format": ""
        },
        {
            "name": "principalType",
            "baseName": "principalType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "scopeId",
            "baseName": "scopeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "scopeKind",
            "baseName": "scopeKind",
            "type": "DirectoryScopeKind",
            "format": ""
        },
        {
            "name": "scopeObjectId",
            "baseName": "scopeObjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "scopeObjectType",
            "baseName": "scopeObjectType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "scopeObjectName",
            "baseName": "scopeObjectName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DirectoryRoleAssignmentSummary.attributeTypeMap;
    }
    constructor() {
    }
}
